import { useDispatch, useSelector } from 'react-redux';
import LoginForm from '@/redux/auth/LoginForm';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { setShowLoginDialog } from '@/redux/global/global.slice';
import { IGlobalState } from '@/redux/global/global';

type LoginButtonProps = {
  className?: string;
  variant:
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link'
    | 'gradient'
    | 'toolbarActive';
};

/**
 * Only a trigger. The dialog itself is rendered once by `LoginDialog` in the
 * navbar: desktop and mobile both render a Login button, and when each carried
 * its own `<Dialog>` the shared `showLoginDialog` flag opened BOTH, leaving two
 * dialogs in the DOM for one click.
 */
export function LoginButton({
  variant,
  className = 'text-white',
}: LoginButtonProps) {
  const dispatch = useDispatch();

  return (
    <Button
      variant={variant}
      className={className}
      aria-haspopup="dialog"
      onClick={() => dispatch(setShowLoginDialog(true))}
    >
      Login
    </Button>
  );
}

function LoginDialog() {
  const dispatch = useDispatch();
  const { showLoginDialog } = useSelector(
    (state: { global: IGlobalState }) => state.global
  );

  return (
    <Dialog
      open={showLoginDialog}
      onOpenChange={(open) => dispatch(setShowLoginDialog(open))}
    >
      <DialogContent className="sm:max-w-[425px]">
        <LoginForm />
      </DialogContent>
    </Dialog>
  );
}

export default LoginDialog;
